import { createClient } from "@supabase/supabase-js";
import { supabaseConfig } from "@/config/app";
import type { Database } from "@/types/supabase";

export const supabase = createClient<Database>(
  supabaseConfig.url,
  supabaseConfig.publishableKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
    },
  },
);
